// Import the functions you need from the SDKs you need.
// firebase v12 modular SDK: these Analytics APIs are unchanged from v9.
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, setUserProperties, setUserId } from 'firebase/analytics';

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_ANALYTICS_API_KEY,
  authDomain: process.env.REACT_APP_ANALYTICS_AUTHDOMAIN,
  projectId: process.env.REACT_APP_ANALYTICS_PROJECTID,
  storageBucket: process.env.REACT_APP_ANALYTICS_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_ANALYTICS_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_ANALYTICS_APPID,
  measurementId: process.env.REACT_APP_ANALYTICS_MEASUREMENTID
};

const userAttributesToInclude = {
  emailAddress: true,
  orgCode: true,
  regionId: true,
  firstName: true,
  lastName: true,
  role: true,
  orgName: true,
  type: true,
  teamId: true,
  teamName: true,
  groupId: true,
  name: true
};

// Tenants that have opted out of Google Analytics entirely, as a comma separated
// list of org codes baked in at build time (Bitbucket deployment variable).
// Empty/absent means GA stays enabled for everyone, i.e. no behaviour change.
const disabledOrgs = new Set(
  (process.env.REACT_APP_ANALYTICS_DISABLED_ORGS || '')
    .split(',')
    .map((orgCode) => orgCode.trim().toUpperCase())
    .filter(Boolean)
);

// null until /self resolves and setUser tells us which tenant this is.
let gaBlocked = null;

// The firebase SDK only injects the googletagmanager gtag script on the first
// getAnalytics() call, so gating every call here blocks GA completely: no script
// download, no cookies, no hits. When no denylist is configured we never gate,
// which keeps the unresolved-tenant window from dropping anyone's events.
const resolveAnalytics = () => {
  if (disabledOrgs.size === 0) return getAnalytics();
  if (gaBlocked !== false) return null;
  return getAnalytics();
};

const init = () => {
  initializeApp(firebaseConfig);
};

const sendEvent = (action, payload) => {
  if (process.env.NODE_ENV === 'production') {
    const analytics = resolveAnalytics();
    if (!analytics) return;
    logEvent(analytics, action, payload);
  } else {
    // Log analytics in development for testing
    console.log('[Analytics]', action, payload);
  }
};

const setUser = (user) => {
  if (!user) return;
  gaBlocked = disabledOrgs.has(
    String(user?.orgCode ?? '')
      .trim()
      .toUpperCase()
  );
  const analytics = resolveAnalytics();
  if (!analytics) return;
  setUserId(analytics, user.id);
  for (let key in user) {
    const userProp = { [key]: user[key] };
    if (userAttributesToInclude[key]) {
      setUserProperties(analytics, userProp);
    }
  }
};
export default {
  init,
  sendEvent,
  setUser
};
